<template>
<div>
  <van-notice-bar
      left-icon="volume-o"
      text="修改密码，请记住修改后的密码。"
  />
  <van-form @submit="onSubmit">
    <van-field
        v-model="oldPassword"
        type="password"
        name="原始密码"
        label="原始密码"
        placeholder="原始密码"
        :rules="[{ required: true, message: '请填写原始密码' }]"
    />
    <van-field
        v-model="password"
        type="password"
        name="密码"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
    />
    <van-field
        v-model="confirmPassword"
        type="password"
        name="确认密码"
        label="确认密码"
        placeholder="确认密码"
        :rules="[{ required: true, message: '请填写确认密码' }]"
    />
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit">提交</van-button>
    </div>
  </van-form>
</div>
</template>

<script>
import {changeUserPwd} from "../../api/system/sys_user";
import {MessageBox} from "mint-ui";

export default {
name: "ChangePassword",
  data(){
  return {
    oldPassword:null,
    password:null,
    confirmPassword:null
  }
  },
  mounted() {
    this.$emit("titleChange", "修改密码");
  },
  methods:{
    onSubmit(){
      if (this.confirmPassword != this.password){
        this.$notify({message: "两次输入的密码不一致！"});
      }else{
        changeUserPwd(this.oldPassword, this.password).then(res=>{
          if (res.success){
            this.logout();
          }
        }).catch(err => {
          MessageBox({
            title: '提示',
            message: err.message,
            showCancelButton: true
          });
        });
      }
    },
    logout() {
      this.$router.push({path: "/"});
      sessionStorage.clear()
      window.location.reload(); //刷一下可以清空vuex-store
    },
  }
}
</script>

<style scoped>

</style>
